import React from 'react';
import { Label } from 'reactstrap';
import { RadioPill } from '../../../../../../components/RadioPill';
import { JobPostingDetailsForm } from '..';

interface PropTypes {
  form: JobPostingDetailsForm;
  onInputChange: (name: string, value: unknown) => void;
}

export function SalaryCurrency(props: PropTypes) {
  return (
    <div>
      <Label>
        Salary Currency <span className='ps-1 text-danger'>*</span>
      </Label>
      <div className='d-flex fs-5'>
        <RadioPill
          name='salaryCurrency'
          id='salaryCurrency-EUR'
          label={'EUR'}
          value={'EUR'}
          selectedValue={props.form.salaryCurrency}
          onChange={() => props.onInputChange('salaryCurrency', 'EUR')}
        />
        <RadioPill
          name='salaryCurrency'
          id='salaryCurrency-USD'
          label={'USD'}
          value={'USD'}
          selectedValue={props.form.salaryCurrency}
          onChange={() => props.onInputChange('salaryCurrency', 'USD')}
        />
        <RadioPill
          name='salaryCurrency'
          id='salaryCurrency-GBP'
          label={'GBP'}
          value={'GBP'}
          selectedValue={props.form.salaryCurrency}
          onChange={() => props.onInputChange('salaryCurrency', 'GBP')}
        />
      </div>
    </div>
  );
}
